<template>
<div>
  <div style="padding-bottom: 60px">
    <header>
      <div class="headerDiv" v-on:click="backHistory"  @click="">
        <img src="@/assets/img/back.png" alt="">
        <p style="color: #FFFFFF">购物车</p>
      </div>
    </header>
    <div class="shopList">

      <van-empty v-if="cartInfoList.length==0" image="error" description="您还没有添加商品" />
      <div class="shopListDiv" v-for="(item,index) in cartInfoList" :key="item.index">
        <div @click="checkShop(item)">
          <van-checkbox v-model="item.checked" icon-size="17px" checked-color="#ee0a24">
            <p class="shopIcon" >
              <!--<span><van-icon name="shop-o" size="18" /></span>-->
              <span><img :src="item.merchant_logo" style="width: 20px" alt=""></span>
              <!--<span>中粮店铺</span>-->
              <span style="display: flex">
                <span>{{item.merchant_title}}</span>
                <span><van-icon name="arrow"/></span>

              </span>
            </p>

          </van-checkbox>
        </div>
        <div class="shopListDetails" v-for="(pros,value) in item.goods" :key="value">
          <van-checkbox checked-color="#ee0a24" icon-size="17px" v-model="pros.isChecked" @click="ischeck(item,pros)"> </van-checkbox>
          <div class="shopListDetailsImg">
            <img :src="pros.img" alt="">
          </div>

          <div class="shopRoduct">
            <p >【{{pros.title}}】</p>
            <p class="shopRoductp" v-if="pros.goods_spec.value">&nbsp;&nbsp;<span class="shopGg" >{{pros.goods_spec.value}}</span></p>
            <p class="shopRoductM"><span style="color: #ee0a24">&nbsp;￥{{toDecimal(pros.goods_spec.total_price)}}</span><span @click="saveCarts(pros)"><van-stepper  v-model="pros.stock" /></span></p>
          </div>
          <p style="display: flex"><van-icon @click="deleteCarts(pros.id)" name="delete-o" size="18px" /></p>
        </div>

      </div>
      <!--为你推荐-->

      <div style="background:#e4e4e4">
        <!--<div style="margin: auto">-->
          <img  style="width: 80px;display: block;margin: auto" src="@/assets/img/lick.png" alt="">
        <!--</div>-->
        <div class="lickDiv">
          <div class="shopDetail" v-for="(item,index) in list" @click="toShopDetail(item.id)" >
            <div class="shopDiv">
              <img :src="item.img" alt="">
            </div>
            <div class="shopMessage">
              <span class="shopMessageName" >{{item.title}}</span>
              <span class="shopMessagePrice"><span style="color: #ff2500">￥{{item.price }}</span>
                <!--<span class="shopMessageF">{{item.sales_volume}} 付款</span></span>-->
            <span class="shopMessageF"><van-icon color="" size="18" name="shopping-cart-o" /></span></span>
            </div>
          </div>

        </div>
      </div>
      <van-submit-bar  :button-text="'结算（'+allCount+'）'" button-color="linear-gradient(to right,#ffd01e,#ee0a24)" @submit="onSubmit">

        <template #default>
          <div class="defalut">
            <p> <van-checkbox checked-color="#ee0a24" icon-size="17px" v-model="isCheckAll" @click="checkAll()">全选</van-checkbox></p>
            <!--你的收货地址不支持同城送, <span @click="onClickEditAddress">修改地址</span>-->
            <p class="orderBottom">
              <!--<span style="color: #dedede">共1件</span>-->
              <span style="font-size: 16px">合计：</span>
              <span style="color: #f56723">￥{{toDecimal(allPrice)}}</span>
            </p>
          </div>

          <!--<button class="button">提交订单</button>-->
        </template>
      </van-submit-bar>
      </div>
  </div>
  <div class="go">
    <img style="width: 60px"  @click="href()" src="@/assets/img/go2.png" alt="">
  </div>
  <van-tabbar route active-color="#ff2500">
    <van-tabbar-item replace to="/home" icon="wap-home-o">
    商城
  </van-tabbar-item>
    <van-tabbar-item replace to="/homeClass" icon="wap-home-o">
      分类
    </van-tabbar-item>
    <van-tabbar-item replace to="/newShop" icon="wap-home-o">
      购物车
    </van-tabbar-item>

    <van-tabbar-item replace to="/myShop" icon="contact">
      我的
    </van-tabbar-item>
  </van-tabbar>
</div>
</template>

<script>
  export default {
    data () {
      return {
        all:false,
        checked:true,
        arr:{},
        list:[],
        arrList:[],
        shopId:[],
        cartInfoList: [],
        isCheckAll: false, // 是否全选
        allPrice: 0, // 所有价格
        allShops: 0, // 被选中的商店数量
        allCount: 0, // 被选中的产品数量
      }
    },
    beforeRouteLeave(to,from,next){
      if(to.path=="/pay"){
        this.$router.push({path:"/home"})
      }
      next()
    },
    methods: {
      backHistory(){
        this.$router.push("/")
      },
      toDecimal(x) {
        var f = parseFloat(x);
//        console.log(isNaN(f))
        if (isNaN(f)) {
          return false;
        }
        var f = Math.round(x*100)/100;
        var s = f.toString();

        var rs = s.indexOf('.');
        if (rs < 0) {
          rs = s.length;
          s += '.';
        }
        while (s.length <= rs + 2) {
          s += '0';
        }
        return s;
        },

        shopLister(){ //推荐商品
        this.$api.shopList()
          .then(res=>{
            for(let i=0;i<10;i++){
              this.list.push(res.data[i])
            }
//            this.list=res.data
          })
      },
      toShopDetail(id){
        this.$router.push({
//            path:"/shopDetail",
          path:"/newShopDetail",
          query:{
            id:id
          }
        })
      },
      selectCartser(){//购物车列表
        this.arr.checked=false
        this.$api.selectCarts({
          "user_id":localStorage.getItem("userid"),
        })
          .then(res=>{
            var arr=[]
//            this.cartInfoList=res.data
            res.data.forEach(data=>{
              arr.push(data)
            })
            arr.forEach(item=>{
              item.checked=false
              item.checkedCount=0
              item.goods.forEach(a=>{
                a.isChecked=false
              })
            })

            this.cartInfoList=[...arr]
          })
          .catch(res=>{
          })
      },
      deleteCarts(id){
        this.$dialog.alert({
          title: '是否删除该商品',
          message: '',
          showCancelButton:true
        }).then(() => {
          this.$api.deleteCarts({
            "id":id,
          }).then(res=>{
            if(res.status==200){
              this.$toast("删除成功")
              this.selectCartser()
            }
          })
        });
      },
      // 选中单个商品
      ischeck (item, pro) {
        // 为未选中的时候改变为false，反之为true
        pro.isChecked ? this._checkTrue(item, pro) : this._checkFalse(item, pro)
      },
      // 修改单个商品的true
      _checkTrue (item, pro) {
        pro.isChecked = true // 将商品选中状态改为true
        // 这里执行了两部，选中商品数量先+1，再与该店铺商品数量比较，如果相等就更改店铺选中状态为true
        if (++item.checkedCount === item.goods.length) {
          item.checked = true
        } else {
          return ''
        }
        // ++item.checkedCount === item.productList.length ? item.checked = true : ''
        // 如果店铺选中状态改为true，选中店铺数量先+1，再与店铺数量比较，如果相等就更改全选选中状态为true
        // // 当商店全选状态，每全选一个商店，被选中商店数加一，数值等于所有商店数，全选状态为true
        if (item.checked) {
          if (++this.allShops === this.cartInfoList.length) {
            this.isCheckAll = true
          } else {
            this.isCheckAll = false
          }
        } else {
          return ''
        }
        // item.checked ? ++this.allShops === this.cartInfoList.length ? this.isCheckAll = true : this.isCheckAll = false : ''
      },
      // 修改单个商品的 false
      _checkFalse (item, pro) {
        pro.isChecked = false // 将商品选中状态改为false
        --item.checkedCount // 被选中的商品数减一
        if (item.checked) {
          // 如果店铺是被选中的，更改店铺选中状态
          item.checked = false // 当商店状态为选中时改变false
          --this.allShops // 商店数减一
        }
        this.isCheckAll = false // 全选状态为false
      },

      // 选择整个商店的商品
      checkShop (item) {
        !item.checked ? this._shopTrue(item) : this._shopFalse(item)
      },
      // 遍历商店每个商品,状态为false的改变为true,又在_checkTrue()方法中将商店状态改为true
      _shopTrue (item) {
        item.goods.forEach(pro => {
          if (pro.isChecked === false) {
            this._checkTrue(item, pro)
          } else {
            return ''
          }
          // pro.isChecked === false ? this._checkTrue(item, pro) : ''
        })
      },
      _shopFalse (item) {
        item.goods.forEach(pro => {
          // 同上
          if (pro.isChecked === true) {
            this._checkFalse(item, pro)
          } else {
            return ''
          }
          //  pro.isChecked === true ? this._checkFalse(item, pro) : ''
        })
      },
      // 选择全部商店的商品，已经计算总价和总数量的函数
      checkAll () {
        // 方法内调用方法
//        this.isCheckAll = !this.isCheckAll
        this.isCheckAll
          ? this.cartInfoList.forEach(item => {
            this._shopTrue(item)
          })
          : this.cartInfoList.forEach(item => {
            this._shopFalse(item)
          })
      },
      _totalPeice () {
        // 每次调用此方法，将初始值为0，遍历价格并累加
        this.allPrice = 0
        this.arrList=[]
        this.cartInfoList.forEach(item => {
          let products = item.goods
          products.forEach(pros => {
            if (pros.isChecked) {
              if(this.arrList.indexOf(pros)>-1)return
              this.arrList.push(pros)
//              this.allPrice += pros.goods_spec.price*100 * pros.stock
              this.allPrice += pros.goods_spec.price * pros.stock
//              this.allPrice = 100.15*100
            }
          })
        })
        this.arrList.forEach((item)=>{
          console.log(item)
          if(this.shopId.indexOf(item.id)>-1)return
          this.shopId.push(item.id)
        })
      },
      _totalCount () {
        // 同上
        this.allCount = 0
        this.cartInfoList.forEach(item => {
          this.allCount += item.checkedCount
        })
      },

      onSubmit () {
        if(this.allCount==0){
          this.$toast("您还没有选择商品哦！")
        }else {
          this.$router.replace({
            path:"/orderPage",
            query:{id:this.shopId}
          })
        }
//        this.$router.push("/orderPage")
      },
      saveCarts(item){//更新购物车
        this.$api.saveCarts({
          id:item.id,
          stock:item.stock,
          goods_spec_id:item.goods_spec.id
        })
          .then(res=>{
            this.selectCartser()
          })
      }
    },
    mounted(){
      this.selectCartser()
      this.shopLister()
//      this.toDecimal(87.521)
    },
    watch: {
      // 深度监听所有数据，每次改变重新计算总价和总数
      cartInfoList: {
        deep: true,
        handler (val, oldval) {
          this._totalPeice()
          this._totalCount()
        }
      }
    }
  }
</script>
<style  scoped="">
  *{
    /*overflow-x:hidden;*/
    padding: 0;
    margin: 0;
  }
  .go{
    position: fixed;
    top: 70%;
    right: 10px;
  }
  header{
    width: 100%;
    height: 50px;
    background:#ff2500 ;
    position: fixed;
    z-index: 200;
    top: 0;

  }
  header img{
    width: 18px;
    height: 18px;
    padding-left: 10px;
  }
  .headerDiv{
    display: flex;
    align-items: center;
    line-height: 50px;
  }
  .headerDiv p{
    margin: auto;
    font-size: 15px;
  }
  .shopList{
    margin-top: 50px;
    background: #E4E4E4;
  }
  .shopListDetailsImg{
    width: 80px;
    height: 80px;
    margin-left: 10px;
  }
  .shopListDetailsImg img{
    width: 100%;
    height: 100%;
  }
  .shopListDetails{
    display: flex;
    padding: 20px 0;
  }
  .shopRoduct{
    margin-left: 1rem;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    /*width: 60%;*/
    flex: 1;
    font-size: 15px;
  }
  .shopRoductp{
    padding-top: 10px;
  }
  .shopListDiv{
    padding: 10px;
    border: solid 7px #E4E4E4;
    border-radius: 1rem;
    background: #ffffff;
  }
  .shopRoductM{
    display: flex;
    justify-content: space-between;
    padding-top: 10px;
  }
  /deep/.van-submit-bar{
    bottom: 50px;
  }
  .shopGg{
    background: #e4e4e4;
    border-radius: 1rem;
    padding: 3px 8px;
  }
  .shopIcon{
    display: flex;
    align-items: center;
    font-size: 15px;
  }
  .shopIcon span{
    margin-left: 5px;
    display: flex;
    align-items: center;
  }
  .orderBottom span{
    padding: 0 2px;
  }
  .orderBottom{
    margin-right: 15px;
  }
  /deep/.van-button{
    right:10px;
  }
  .defalut{
    display: flex;
    align-items: center;
    /* width: 62%; */
    flex: 1;
    justify-content: space-around;
  }
  /*猜你喜欢*/
  .lickDiv{
    display:flex ;
    flex-wrap:wrap;
    background: #e4e4e4;
    margin-bottom: 35px;
    padding-bottom: 10px;
    /*justify-content: center;*/
  }
  .shopDiv{
    width: 100%;
    /*height: 120px;*/
    /*background: #6e9bcf;*/
    border-radius: 1rem;
    /*margin-left: 1px;*/
    /*margin: 10px;*/
  }
  .shopDiv img{
    width: 100%;
    /*height: 100%;*/
  }
  .shopDetail{
    /*width: 40%;*/
    /*margin: 8px 5%;*/
    /*color: #898888;*/

    width: 40%;
    margin: 8px 0 1% 4%;
    color: #898888;
    background: #ffffff;
    padding: 3%;
    margin-left: 10px;
  }
  .shopMessageName{
    display: block;
    color: #898888;
  }
  .shopMessagePrice{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .shopMessage span{
    padding-top: 2px;
  }
  .shopMessageName:first-child{
    /*font-size: 18px;*/
  }
  .shopMessageName:last-child{
    /*font-size: 12px;*/
  }
  .shopMessageF{
    font-size: 12px;
    margin-left: 10px;
  }
  .shopMessage{
    /*text-align: center;*/
  }
  .messageLine{
    text-decoration: line-through;
    margin-left: 10px;
  }
  .shopMessage{
    font-size: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/components/shop/newShop.vue